<template>
    <div v-if="show" class="modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">Quick reminders</p>
            </header>
            <section class="modal-card-body">
                <h1 class="title is-5">1. Mark all the deliveries</h1>
                <p>Please mark each and every delivery whether it was delivered or not</p>
                <br>
                <h1 class="title is-5">2. Don't leave the bags</h1>
                <p>Please don't leave the bags with anyone else (like neighbour or friend), or at the door.</p>
                <p>If you don't find the beneficiary, please bring back the bag.</p>
            </section>
            <footer class="modal-card-foot">
                <button class="button is-info is-rounded is-medium" @click="close">Got it!</button>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: localStorage.getItem('quick_reminders_seen') !== 'true'
        }
    },
    methods: {
        close() {
            localStorage.setItem('quick_reminders_seen', 'true');
            this.show = false;
        }
    }
}

</script>

<style scoped>
.footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    text-align: left;
    padding: 0;
}

table td {
    padding: 0;
    vertical-align: middle;
}
</style>